import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Input, Form, Row, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { PrinterOutlined, MailOutlined } from '@ant-design/icons';

const PrintSignSepaModal = ({
  modalVisible,
  setModalVisible,
  printSepa,
  signSepa,
  isDownloading,
  downloading,
  contract,
  user
}) => {
  const { t } = useTranslation();
  const isCustomer = user?.role === 'guests:GUEST';

  return (
    <>
      <Modal
        title={t('contracts.modal_sepa.title')}
        centered
        open={modalVisible}
        width={900}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={[
          <div style={{ textAlign: 'center', fontWeight: 700 }}>
            {t('contracts.modal_sepa.modal_obligation')}
          </div>
        ]}
      >
        <div style={{ textAlign: 'center', fontWeight: 700 }}>
          {t(
            `contracts.modal_sepa.explanation${isCustomer ? '_customer' : ''}`
          )}
        </div>
        <Row justify="space-around" style={{ marginTop: 40, marginBottom: 40 }}>
          <Button
            onClick={signSepa}
            type="primary"
            style={{
              width: 'auto',
              padding: '4px 15px'
            }}
            loading={downloading}
          >
            <span
              style={{
                display: 'inline'
              }}
            >
              {t('contracts.form.title.action.sign_mail')}
            </span>
            <MailOutlined />
          </Button>
          <Popover
            content={t(
              `contracts.modal_sepa.popover${isCustomer ? '_customer' : ''}`
            )}
          >
            <Button
              onClick={() => printSepa('signPrintContract')}
              type="primary"
              style={{
                width: 'auto',
                padding: '4px 15px'
              }}
              loading={isDownloading}
            >
              <span
                style={{
                  display: 'inline'
                }}
              >
                {t('contracts.modal_sepa.print_sepa')}
              </span>
              <PrinterOutlined />
            </Button>
          </Popover>
        </Row>
        {contract && contract?.customer?.email ? (
          []
        ) : (
          <div>
            <div>{t('contracts.modal.email')}</div>
            <Form>
              <Form.Item
                name="email"
                label={<MailOutlined />}
                rules={[
                  {
                    required: true,
                    type: 'email'
                  }
                ]}
              >
                <Input
                  style={{ width: '200px' }}
                  placeholder={t('insurers.form.owner_email')}
                />
              </Form.Item>
            </Form>
          </div>
        )}
      </Modal>
    </>
  );
};

PrintSignSepaModal.propTypes = {
  modalVisible: PropTypes.bool.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  printSepa: PropTypes.func.isRequired,
  signSepa: PropTypes.func.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  downloading: PropTypes.bool.isRequired,
  contract: PropTypes.shape({
    customer: PropTypes.shape({
      email: PropTypes.string
    })
  }).isRequired,
  user: PropTypes.shape({
    role: PropTypes.string
  }).isRequired,
  form: PropTypes.shape({
    validateFields: PropTypes.func
  }).isRequired
};

export default PrintSignSepaModal;
